import { render, staticRenderFns } from "./ClinicPageBulkArchiveDialog.vue?vue&type=template&id=9945e662"
import script from "./ClinicPageBulkArchiveDialog.vue?vue&type=script&lang=js"
export * from "./ClinicPageBulkArchiveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports